import { render, staticRenderFns } from "./PartnerCruiseItem.vue?vue&type=template&id=2b660932&scoped=true"
import script from "./PartnerCruiseItem.vue?vue&type=script&lang=js"
export * from "./PartnerCruiseItem.vue?vue&type=script&lang=js"
import style0 from "./PartnerCruiseItem.vue?vue&type=style&index=0&id=2b660932&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b660932",
  null
  
)

export default component.exports